module.exports = __webpack_public_path__ + "static/media/nameLogoBlack.6c70fe69.png";